import { render, staticRenderFns } from "./IR-Financial Information_CreateEdit.vue?vue&type=template&id=feab6324&"
import script from "./IR-Financial Information_CreateEdit.vue?vue&type=script&lang=js&"
export * from "./IR-Financial Information_CreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
